import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { MapPin } from '@phosphor-icons/react';

const areas = [
  'Tuggerah', 'Chittaway Bay', 'The Entrance', 'Gosford', 'Erina', 
  'Terrigal', 'Wyong', 'Toukley', 'Woy Woy', 'Umina Beach', 
  'Tea Gardens', 'Swansea', 'North Lakes'
];

const ServiceAreas = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section 
      id="service-areas" 
      data-testid="service-areas-section"
      className="section-padding bg-primary-bg"
      ref={ref}
    >
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <p className="overline mb-4">Service Areas</p>
            <h2 
              data-testid="service-areas-heading"
              className="text-4xl sm:text-5xl font-heading font-light text-heading mb-8"
            >
              Serving the<br />Central Coast
            </h2>
            
            <p className="text-body-text leading-relaxed mb-8">
              Rimsie Constructions Pty Ltd works across the full Central Coast region 
              and surrounding areas. Local knowledge, local trades.
            </p>

            <div className="flex flex-wrap gap-3">
              {areas.map((area) => (
                <span
                  key={area}
                  data-testid={`area-tag-${area.toLowerCase().replace(' ', '-')}`}
                  className="flex items-center gap-2 bg-secondary-bg border border-border-subtle px-4 py-2 text-sm text-heading"
                >
                  <MapPin size={14} className="text-accent" />
                  {area}
                </span>
              ))}
            </div>
          </motion.div>

          {/* Map */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="map-container"
          >
            <div className="aspect-square lg:aspect-[4/3] w-full border border-border-subtle overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26471.55686538698!2d151.41!3d-33.31!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b72c66c1a8c0dcf%3A0x40609b490430f90!2sTuggerah%20NSW%202261%2C%20Australia!5e0!3m2!1sen!2sus!4v1699000000000!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Rimsie Constructions Pty Ltd Location - Tuggerah NSW"
                data-testid="google-map"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
